import React, { useState, useEffect } from "react";
import { User } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

const ProfileAvatar = ({ onClick }) => {
  const { user, userProfile } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    if (!user?.uid) return;

    const userDocRef = doc(db, "users", user.uid);
    const unsubscribe = onSnapshot(userDocRef, (doc) => {
      if (doc.exists()) {
        setAvatarUrl(doc.data().avatarUrl);
      }
    });

    return () => unsubscribe();
  }, [user?.uid]);

  return (
    <button
      className="profile-avatar-button"
      onClick={onClick}
      title="View Profile"
    >
      {avatarUrl ? (
        <div
          className="profile-avatar-image"
          style={{ backgroundImage: `url(${avatarUrl})` }}
        />
      ) : (
        <div className="profile-avatar">
          {userProfile?.firstName ? (
            userProfile.firstName[0].toUpperCase()
          ) : (
            <User size={20} />
          )}
        </div>
      )}
    </button>
  );
};

export default ProfileAvatar;
